module.exports = __webpack_public_path__ + "static/loading-634c5c990e45dd1e1b8029652220d7bc.gif";